import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    step: 0,
    values: {},

};

const forgetPasswordSlice = createSlice({
    name: 'forgetPasswordRedux',
    initialState,
    reducers: {
        nextStep(state) {
            state.step += 1;
        },
        prevStep(state) {
            state.step -= 1;
        },
        updateValuesOnChange(state, action) {
            const { key, value } = action.payload;
            state.values[key] = value;
        },
        resetForgotPassValues(state) {
            state.step = initialState.step;
            state.values = initialState.values;
        }
    },
});

export const { nextStep, prevStep, updateValuesOnChange, resetForgotPassValues } = forgetPasswordSlice.actions;

export default forgetPasswordSlice.reducer;


